import { alertVariants } from "@visiblethread/react-components";
import localhost from "apis/localhost";
import { licenseSetupConfirmationModal } from "components/Modal/confModalTypes";
import {
  MULTIPART_FORM_DATA_CONTENT_TYPE,
  URLENCODED_FORM_CONTENT_TYPE,
} from "constants/app";
import { modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal, showModal } from "slices/app/actions/modals";
import { pageLoading, showGlobalAlert } from "slices/app/appSlice";
import { setLicenseInfo } from "slices/systemAdmin/systemAdminSlice";

export const fetchLicenseInfo = () => async (dispatch) => {
  await localhost
    .get("/systemAdmin/license")
    .then(async (response) => {
      const { data } = response;
      dispatch(setLicenseInfo(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(pageLoading(false));
    });
};

export const uploadLicense = (formData) => async (dispatch) => {
  dispatch(pageLoading(true));

  await localhost
    .post("/systemAdmin/license/upload", formData, {
      headers: {
        "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE,
      },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setLicenseInfo(data.licenseInfo));
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(
        showGlobalAlert({
          variant: alertVariants.success,
          text: data.successMessage,
        })
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(pageLoading(false));
    });
};

export const updateLicense =
  (workspaceId, licenseType, numberUsers, expiryDate, notes, handleSuccess) =>
  async (dispatch, getState) => {
    dispatch(pageLoading(true));
    const { adminType } = getState().systemAdmin;
    await localhost
      .post(
        `/${adminType}/license`,
        { workspaceId, licenseType, numberUsers, expiryDate, notes },
        {
          headers: {
            "Content-Type": URLENCODED_FORM_CONTENT_TYPE,
          },
        }
      )
      .then(() => {
        handleSuccess();
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(pageLoading(false));
      });
  };

export const licenseSetup = (formData) => async (dispatch) => {
  dispatch(pageLoading(true));
  await localhost
    .post("/systemAdmin/setupLicense", formData, {
      headers: {
        "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE,
      },
    })
    .then(async () => {
      const redirectToLogin = () => {
        window.location.href = "/";
      };

      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          licenseSetupConfirmationModal(dispatch, redirectToLogin)
        )
      );
    })
    .catch((error) => {
      dispatch(hideModal(modalTypes.NEW_USER));
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(pageLoading(false));
    });
};
